<template>
  <controller :lockScroll="ls">
    <section :class="['ca-controller', { 'matriculas-v2-active': matriculasV2.active }]">
      <template v-if="matriculasV2.active">
        <div class="matriculas-v2-embed">
          <div class="matriculas-v2-frame-wrap">
            <button
              type="button"
              class="matriculas-v2-close"
              @click="closeMatriculasV2"
            >
              Voltar para Central
            </button>
            <div v-if="matriculasV2.loading" class="matriculas-v2-state">
              <span class="loader"></span>
              <p>Validando acesso e abrindo Matrículas V2...</p>
            </div>
            <div v-else-if="matriculasV2.error" class="matriculas-v2-state error">
              <p>{{ matriculasV2.error }}</p>
              <button type="button" @click="retryMatriculasV2">
                Tentar novamente
              </button>
            </div>
            <iframe
              v-else
              ref="matriculasV2Frame"
              :src="matriculasV2.url"
              title="Matrículas V2"
              allow="clipboard-read; clipboard-write"
              @load="onMatriculasV2IframeLoad"
            ></iframe>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="{ small: active != 'matriculas' }">
          <info-bar
            :aluno="alunoFull"
            v-if="alunoFull"
            class="infoBar"
            @onToggleEdit="toggleEdit($event)"
            @openModalEditPessoa="openModalEditPessoa"
            @photoUpdated="updateAlunoPhoto"
            ref="infoBar"
          />
        </div>
        <div :class="{ large: active != 'matriculas' }">
          <matriculas
            v-if="alunoFull && active == 'matriculas'"
            :aluno="alunoFull"
            @onModal="toggleModal"
            @onRespFin="respFin = $event"
            @onRespPed="respPed = $event"
            @onResponsaveisFinanceiros="responsaveisFinanceiros = $event"
            @onCreateFilter="setPeriodoList"
            @onRemoveItinerarios="confirmRemoveItinerario"
            @onOpenHistorico="openHistorico"
            @openTrocaRespFin="openTrocaRespFin"
            @openMatriculasV2="openMatriculasV2"
            @openModalEditPessoa="openModalEditPessoa"
            ref="matriculas"
          />
          <bloqueios :idAluno="alunoFull.Aluno.idAluno" v-if="alunoFull && active == 'bloqueios'" @goBack="active = 'matriculas'" />
          <negociacoes :idAluno="alunoFull.Aluno.idAluno" :aluno="alunoFull" v-if="alunoFull && active == 'negociacoes'" @goBack="active = 'matriculas'" />
        </div>
        <div>
          <toolbar
            :aluno="alunoFull"
            :fin="respFin"
            :ped="respPed"
            :responsaveis-financeiros="responsaveisFinanceiros"
            v-if="alunoFull"
            @onAddPanel="addPanel"
            @onModal="toggleModal"
            @onNavigation="toggleNavigation"
          />
        </div>
      </template>
    </section>
    <template v-if="painel && alunoFull && periodosLetivos && selectedPeriodo">
      <painel :aluno="alunoFull" :painel="painel" @onGoBack="removePanel()" :periodosLetivos="periodosLetivos" :pl="selectedPeriodo"/>
    </template>
    <modal ref="modal">
      <documentos v-if="modalContent == 'documentos'" :id="idMatricula" @onclose="closeModalControl()" :validation="addEditDocumento" :reenvioContrato="reenvioContrato" :matricula="selectedMatricula" />
      <boletos v-if="modalContent == 'boletos'" :matricula="idMatricula" :gestao="true" />
      <div v-if="modalContent == 'itinerarios'">
        <itinerarios :itinerarios="itinerarios" :matriculas="matriculasItinerarios" :matricula="idMatricula" @save="closeModalControl(true)" @close="closeModalControl()" />
      </div>
      <div v-if="modalContent == 'remanejamento'">
        <remanejamento :idMatricula="idMatricula" @onClose="closeModalControl($event)" />
      </div>
    </modal>
    <modal ref="modalHistorico">
      <HistoricoMatricula
        v-if="showHistorico"
        :id-matricula="historicoId"
        @close="closeHistorico"
      />
    </modal>
    <modal ref="modalEditPessoa">
      <EditPessoa
          v-if="showEditPessoa"
          :idPessoa="idPessoaEditable"
          :branch="branchEditable"
          :personContext="editPessoaContext"
          :action="'editar'"
          @closeModalPessoa="closeModalEditPessoa"
      />
    </modal>
    <modal ref="modalFichas">
      <ficha-saida v-if="ficha && ficha == 'fichaSaida'" :idMatricula="idMatricula" @refreshSaida="refreshSaida()"/>
      <ficha-saude v-if="ficha && ficha == 'fichaSaude'" :idMatricula="idMatricula" @refreshSaude="refreshSaude()"/>
    </modal>
    <confirm
      :backdrop="false"
      class="confirm"
      ref="confirm"
    ></confirm>
  </controller>
</template>

<script>
import InfoBar from '@/components/centralaluno/template/InfoBar.vue'
import Matriculas from '@/components/centralaluno/template/Matriculas.vue'
import Toolbar from '@/components/centralaluno/template/Toolbar.vue'
import Painel from '@/components/centralaluno/template/Painel.vue'
import Modal from "@/components/utilities/Modal.vue"
import Remanejamento from '@/views/matriculas/remanejamento/Remanejamento.vue'
import Boletos from '@/views/boletos/Boletos.vue'
import Documentos from '@/views/centralaluno/Documentos.vue'
import Itinerarios from '@/views/centralaluno/Itinerarios.vue'
import Bloqueios from '@/views/centralaluno/Bloqueios.vue'
import Negociacoes from "@/views/centralaluno/Negociacoes.vue"
import EditPessoa from "@/components/centralaluno/Controllers/Controller.vue"

import UserService from '@/services/user.service.js'
import MatriculaService from '@/services/matricula.service.js'
import MatriculasV2Service from '@/services/matriculas-v2.service.js'
import HistoricoMatricula from '@/components/matriculas/utilities/HistoricoMatricula.vue'
import FichaSaida from '@/views/matriculas/etapas/FichaSaida.vue'
import FichaSaude from '@/views/matriculas/etapas/FichaSaude.vue'

export default {
  components: {
    InfoBar, Matriculas, Toolbar, Painel,
    Remanejamento, Modal, Boletos, Documentos,
    Itinerarios, Bloqueios, Negociacoes,
    HistoricoMatricula, EditPessoa,
    FichaSaida, FichaSaude
  },
  props: {
    idPessoa: {
      type: [ Number, String ]
    },
    idAluno: {
      type: [ Number, String ]
    },
    action: {
      type: [ Number, String ]
    }
  },
  watch: {
    action ( value ) {
      if ( value ) this.painel = value
    }
  },
  data () {
    return {
      alunoFull: null,
      aluno: null,
      painel: null,
      ls: false,
      active: 'matriculas',
      idMatricula: null,
      modalContent: null,
      periodosLetivos: null,
      selectedPeriodo: null,
      viewDocumento: false,
      addEditDocumento: false,
      reenvioContrato: false,
      itinerarios: null,
      matriculasItinerarios: null,
      selectedMatricula: null,
      respFin: null,
      respPed: null,
      responsaveisFinanceiros: [],
      showHistorico: false,
      historicoId: null,
      showEditPessoa: false,
      idPessoaEditable: null,
      branchEditable: null,
      editPessoaContext: null,
      ficha: null,
      matriculasV2: {
        active: false,
        loading: false,
        url: null,
        error: null,
        matricula: null,
        redirectTo: null
      },
      matriculasV2HeartbeatTimer: null,
      matriculasV2Reauthenticating: false
    }
  },
  mounted () {
    this.viewDocumento = UserService.filterPermissions('viewDocumento')
    this.addEditDocumento = UserService.filterPermissions('addEditDocumento')
    this.reenvioContrato = UserService.filterPermissions('reenvioContrato')

    this.getAluno()
    window.pagescroll.emit("unlock")

    if ( this.action ) {
      this.addPanel(this.action)
    }

    window.addEventListener('message', this.onMatriculasV2Message)
    window.addEventListener('matriculas-v2:apollo-logout', this.logoutMatriculasV2Iframe)
  },
  beforeUnmount () {
    this.stopMatriculasV2Heartbeat()
    window.removeEventListener('message', this.onMatriculasV2Message)
    window.removeEventListener('matriculas-v2:apollo-logout', this.logoutMatriculasV2Iframe)
  },
  methods: {
    updateAlunoPhoto ( urlFoto ) {
      this.alunoFull.Basicos.urlFoto = urlFoto
    },
    getAluno () {
      MatriculaService.getPessoaCentralAluno(this.idPessoa,0).then(
        response => {
          console.log("getPessoaCentralAluno:", response.data)
          if ( Object.keys(response.data).length > 0 ) {
            this.alunoFull = response.data.dados

            const base = response.data.dados
            const aluno = {
              id: base.Aluno.idAluno,
              nome: base.Basicos.nome,
              rm: base.Aluno.rm,
              nascimento: base.Basicos ? base.Basicos.dataNascimento : "-",
              rg: base.Documento ? base.Documento.rg : "-",
              cpf: base.Documento ? base.Documento.cpf : "-",
              email: base.Aluno ? base.Aluno.emailAcademico : "-",
              genero: base.Basicos ? base.Basicos.sexo : "-",
              idRespFin: base.Aluno.responsavelFinanceiro?.idPessoa ?? "-",
              idRespPed: base.Aluno.responsavelPedagogico?.idPessoa ?? "-"
            }

            console.log("getPessoaByIdPessoaOuCpf:", base)
            this.aluno = aluno

            // if ( base.Aluno.responsavelFinanceiro ) {
            //   this.getRespFin(base.Aluno.responsavelFinanceiro.idPessoa)
            // }
            // if ( base.Aluno.responsavelPedagogico ) {
            //   this.getRespFin(base.Aluno.responsavelPedagogico.idPessoa)
            // }
            // if ( base.Basicos.idPessoaPai ) this.fetchParents('1', base.Basicos.idPessoaPai)
            // if ( base.Basicos.idPessoaMae ) this.fetchParents('2', base.Basicos.idPessoaMae)
        }
        },
        () => {

        }
      )
    },
    openModalEditPessoa ( idPessoa, branch, personContext = null ) {
      this.idPessoaEditable = idPessoa
      this.branchEditable = branch
      this.editPessoaContext = personContext
      this.showEditPessoa = true

      const options = {
        title: 'Atualizar Dados Cadastrais',
        titleAlign: 'left',
        message: '',
        size: 'extra-large',
        backdrop: true,
        backdropColor: 'blur',
        backdropClose: true,
        fullHeight: true,
        padding: '10',
        onClose: this.resetModalEditPessoa
      }
      this.$nextTick(() => {
        this.$refs.modalEditPessoa.open(options)
      })
    },
    openTrocaRespFin (idMatricula, Matricula = null) {
      const matricula = Matricula || { idMatricula }
      this.idMatricula = matricula.idMatricula
      this.selectedMatricula = matricula
      this.openMatriculasV2(matricula, `/matriculas/${matricula.idMatricula}/financeiro`)
    },
    closeModalEditPessoa ( update ) {
      this.$refs.modalEditPessoa.close()

      if ( update ) {
        this.getAluno()

        this.$nextTick(() => {
          if ( this.$refs.matriculas ) this.$refs.matriculas.getMatriculas()
        })
      }
    },
    resetModalEditPessoa () {
      const branch = this.branchEditable || 'Basic'

      this.showEditPessoa = false
      this.idPessoaEditable = null
      this.branchEditable = null
      this.editPessoaContext = null

      // Limpa o branch usado pela edição para não reter dados da pessoa anterior.
      this.$store.dispatch('matricula/clear', branch)
    },
    refreshSaida () {
      this.ficha = null
      this.$refs.modalFichas.close()
      this.$refs.infoBar.$refs.fichaSaida.getFichaSaida()
    },
    refreshSaude () {
      this.ficha = null
      this.$refs.modalFichas.close()
      this.$refs.infoBar.$refs.fichaSaude.getFichaSaude()
    },
    openHistorico (idMatricula) {
      if (!idMatricula) return

      const options = {
        title: 'Histórico da Matrícula',
        titleAlign: 'left',
        message: '',
        size: 'large',
        backdrop: true,
        backdropColor: 'blur',
        backdropClose: true,
        fullHeight: false,
        padding: '0'
      }

      this.historicoId = idMatricula
      this.showHistorico = true
      this.$nextTick(() => this.$refs.modalHistorico.open(options))
    },
    closeHistorico () {
      this.showHistorico = false
      this.historicoId = null
      if (this.$refs.modalHistorico) this.$refs.modalHistorico.close()
    },
    getRespFin ( idPessoa ) {
      console.log("idPessoa", idPessoa)
      if ( idPessoa ) {
        MatriculaService.getPessoaByIdPessoaOuCpf(idPessoa,0).then(
          response => {
            console.log("getRespFin:", response.data)
            if ( Object.keys(response.data).length > 0 ) {
              this.responsavel = response.data
            }
          },
          () => {

          }
        )
      }
    },
    async openMatriculasV2 (matricula, redirectOverride = null) {
      if (!matricula?.idMatricula) return

      this.ls = true
      const isMatricula = this.isMatriculaFlow(matricula)
      const redirectTo = isMatricula
        ? `/matricula/editar/aluno/${matricula.idMatricula}`
        : `/rematricula/editar/matricula/${matricula.idMatricula}`
      const finalRedirectTo = this.redirectFromMatriculasV2Href(redirectOverride) || redirectTo

      this.stopMatriculasV2Heartbeat()
      this.matriculasV2 = {
        active: true,
        loading: true,
        url: null,
        error: null,
        matricula,
        redirectTo: finalRedirectTo
      }

      try {
        this.matriculasV2.url = await MatriculasV2Service.redirectUrl({
          redirectTo: finalRedirectTo,
          embedded: true
        })
      } catch (error) {
        this.matriculasV2.error = error.response?.data?.message || error.message || 'Não foi possível abrir o Matrículas V2.'
      } finally {
        this.matriculasV2.loading = false
      }
    },
    retryMatriculasV2 () {
      const matricula = this.matriculasV2.matricula
      if (matricula) this.openMatriculasV2(matricula)
    },
    closeMatriculasV2 () {
      if (!this.painel) this.ls = false
      this.matriculasV2 = {
        active: false,
        loading: false,
        url: null,
        error: null,
        matricula: null,
        redirectTo: null
      }
      this.stopMatriculasV2Heartbeat()
    },
    isMatriculaFlow (matricula) {
      const status = Number(matricula.idSituacao)
      return status === 1 || status === 12 || (matricula.situacaoMatricula === 1 && matricula.situacaoRematricula !== 1)
    },
    onMatriculasV2IframeLoad () {
      this.startMatriculasV2Heartbeat()
      this.sendMatriculasV2IframeMessage('matriculas-v2:keepalive')
    },
    startMatriculasV2Heartbeat () {
      this.stopMatriculasV2Heartbeat()
      this.matriculasV2HeartbeatTimer = window.setInterval(() => {
        this.sendMatriculasV2IframeMessage('matriculas-v2:keepalive')
      }, 5 * 60 * 1000)
    },
    stopMatriculasV2Heartbeat () {
      if (this.matriculasV2HeartbeatTimer) {
        window.clearInterval(this.matriculasV2HeartbeatTimer)
        this.matriculasV2HeartbeatTimer = null
      }
    },
    sendMatriculasV2IframeMessage (type) {
      this.$refs.matriculasV2Frame?.contentWindow?.postMessage({ type }, '*')
    },
    logoutMatriculasV2Iframe () {
      this.sendMatriculasV2IframeMessage('matriculas-v2:logout')
    },
    onMatriculasV2Message (event) {
      if (event.source !== this.$refs.matriculasV2Frame?.contentWindow) {
        return
      }

      const payload = event.data || {}
      if (payload.source !== 'matriculas-v2') {
        return
      }

      if (payload.type === 'matriculas-v2:ready' && payload.href) {
        const redirect = this.redirectFromMatriculasV2Href(payload.href)
        if (redirect) this.matriculasV2.redirectTo = redirect
      }

      if (payload.type === 'matriculas-v2:session-expired') {
        this.reauthenticateMatriculasV2(payload.href)
      }
    },
    reauthenticateMatriculasV2 (href) {
      if (this.matriculasV2Reauthenticating || !this.matriculasV2.matricula) {
        return
      }

      this.matriculasV2Reauthenticating = true
      this.openMatriculasV2(this.matriculasV2.matricula, href || this.matriculasV2.redirectTo)
      window.setTimeout(() => {
        this.matriculasV2Reauthenticating = false
      }, 1500)
    },
    redirectFromMatriculasV2Href (href) {
      if (!href || typeof href !== 'string') {
        return null
      }

      try {
        const url = new URL(href, window.location.origin)
        const redirect = `${url.pathname}${url.search}`
        return redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : null
      } catch {
        return null
      }
    },
    addPanel ( painel ) {
      this.painel = painel
      this.ls = true
    },
    removePanel () {
      this.painel = null
      this.ls = false
    },
    toggleModal  ( options ) {
      const modalOptions = {
        title: options.target,
        titleAlign: "left",
        // message: "Se quiser uma mensagem...", //não obrigatório
        size: options.size ?? "large", //small, mid, large, full
        backdrop: true,
        backdropColor: "blur",  //se o backdrop for false, não precisa
        backdropClose: true, //se o backdrop for false, não precisa
      }

      // console.log("options.matricula", options.matricula)

      this.idMatricula = options.matricula.idMatricula
      this.selectedMatricula = options.matricula
      this.itinerarios = options.matricula.itinerariosDisponiveis
      this.matriculasItinerarios = options.matricula.itinerariosInscritos
      this.modalContent = options.target

      this.$refs.modal.open(modalOptions)
    },
    toggleNavigation ( target ) {
      this.active = target
    },
    closeModalControl ( update ) {
      this.$refs.modal.close()

      if ( update ) {
        // console.log("update matriculas..")
        this.$nextTick(() => {
          this.$refs.matriculas.getMatriculas()
        })
      }
    },
    setPeriodoList ( options ) {
      this.periodosLetivos = options.periodos
      this.selectedPeriodo = options.selected
    },
    confirmRemoveItinerario ( options ) {
      this.$refs.confirm.run({
        message: "Tem certeza que deseja remover o itinerário selecionado?",
        confirmButton: "Sim",
        denyButton: "Não",
        data: [ options.matricula.idMatricula, options.itinerario.idItinerariosInscritos ],
        callback: this.removeItinerario
      })
    },
    removeItinerario (state, data) {
      if ( state ) {
        const matricula = data[0]
        const itinerario = [data[1]]
        window.spinner.emit('open')
        MatriculaService.desmatricularItinerarios(matricula, itinerario).then(
          response => {
            console.log("response:", response)
            if ( response.status == 200 || response.status == 201 ) {
              window.toaster.emit('open', {style: "success", message: "Tudo certo, itinerário removido com sucesso.", floater: true})

              this.$nextTick(() => {
                this.$refs.matriculas.getMatriculas()
              })
            }

            window.spinner.emit('close')
          },
          error => {
            console.log("error:", error)
            window.toaster.emit('open', {style: "error", message: "Ops. Algo deu errado. Não conseguimos remover a matricula do aluno no itinerário selecionado.", floater: true})
            window.spinner.emit('close')
          }
        )
      }
    },
    toggleEdit(options) {
      this.idMatricula = options.e
      console.log("toggleEdit:", options)
      console.log("toggleEdit - target:", options.target)

      this.ficha = options.target

      const modalOptions = {
        title: 'Ficha de Saída',
        titleAlign: "left",
        // message: "Se quiser uma mensagem...", //não obrigatório
        size: "large", //small, mid, large, full
        backdrop: true,
        backdropColor: "blur",  //se o backdrop for false, não precisa
        backdropClose: true, //se o backdrop for false, não precisa
      }


      this.$refs.modalFichas.open(modalOptions)
    }
  }
}
</script>

<style lang="scss" scoped>
  .ca-controller {
    display: flex; align-content: stretch;
    min-height: calc( 100vh - 60px );

    &.matriculas-v2-active {
      height: 100%;
      min-height: 0;
      overflow: hidden;
    }

    .matriculas-v2-embed {
      background-color: $color-bg;
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      overflow: hidden;
      width: 100%;

      .matriculas-v2-frame-wrap {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        position: relative;
      }

      .matriculas-v2-close {
        background-color: $color-primary;
        border: 0;
        border-radius: 16px;
        color: $color-secondary;
        cursor: pointer;
        font-size: 12px;
        font-weight: bold;
        min-height: 28px;
        padding: 0 $mg_small;
        position: absolute;
        right: 32px;
        top: 8px;
        z-index: 2;
      }

      iframe {
        border: 0;
        display: block;
        height: 100%;
        min-height: 0;
        width: 100%;
      }

      .matriculas-v2-state {
        align-items: center;
        color: $color-text;
        display: flex;
        flex-direction: column;
        font-weight: bold;
        gap: $hmg_small;
        justify-content: center;
        min-height: 520px;
        padding: $mg;
        text-align: center;

        &.error {
          color: $color-primary;

          button {
            background-color: $color-primary;
            border: 0;
            border-radius: 24px;
            color: $color-secondary;
            cursor: pointer;
            font-weight: bold;
            min-height: 36px;
            padding: 0 $hmg_mid;
          }
        }
      }

      .loader {
        animation: spin .8s linear infinite;
        border: 3px solid rgba($color-primary, .2);
        border-radius: 50%;
        border-top-color: $color-primary;
        height: 34px;
        width: 34px;
      }
    }

    > div {
      flex: 1;
      width: 40%;
      position: relative;
      @extend %transition_6e;

      &:nth-child(1) {
        background-color: $color-secondary;
        border-right: $border-component;
        z-index: 11;

        &.small {
          width: 30%;
          max-width: 30%;
        }
      }
      &:nth-child(2) {
        z-index: 10;
        // background-color: $color-secondary;
        // border-right: $border-component;
        &.large {
          width: 50%;
        }
      }
      &:nth-child(3) {
        max-width: 320px; min-width: 300px;
        border-left: $border-component;
        z-index: 13;

        @media screen and ( max-width: 1366px ) {
          max-width: 280px; min-width: 240px;
        }

        @media screen and ( max-width: 1024px ) {
          max-width: 100%; min-width: 100%;
        }
      }
    }

    @media screen and ( max-width: 1024px ) {
      display: block;

      >div {
        width: 100%;
      }
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
